import script from "./BotChatLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BotChatLayout.vue?vue&type=script&setup=true&lang=js"

import "./BotChatLayout.vue?vue&type=style&index=0&id=12d65aa1&lang=scss"

const __exports__ = script;

export default __exports__